/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-tree-list-col-count-by-screen',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoTreeListColCountByScreenComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get lg(): number | undefined {
        return this._getOption('lg');
    }
    set lg(value: number | undefined) {
        this._setOption('lg', value);
    }

    @Input()
    get md(): number | undefined {
        return this._getOption('md');
    }
    set md(value: number | undefined) {
        this._setOption('md', value);
    }

    @Input()
    get sm(): number | undefined {
        return this._getOption('sm');
    }
    set sm(value: number | undefined) {
        this._setOption('sm', value);
    }

    @Input()
    get xs(): number | undefined {
        return this._getOption('xs');
    }
    set xs(value: number | undefined) {
        this._setOption('xs', value);
    }


    protected get _optionPath() {
        return 'colCountByScreen';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoTreeListColCountByScreenComponent
  ],
  exports: [
    DxoTreeListColCountByScreenComponent
  ],
})
export class DxoTreeListColCountByScreenModule { }
